import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useHasPermission } from '../../permission/PermissionUtil';
import TextInputDialog from './TextInputDialog';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function ExecuteCommandButton() {

    const [commandExecutePrompt, setCommandExecutePrompt] = useState(null);

    const executeCommand = async (command) => {
        setCommandExecutePrompt(null);
        await axios.post('/command', command);
        toast.success("Command executed");
    };

    const hasExecuteCommandPermission = useHasPermission("Command:Execute");

    if (!hasExecuteCommandPermission) {
        return null;
    }

    return (
        <>
            <TextInputDialog prompt={commandExecutePrompt} onConfirm={executeCommand} onClose={() => setCommandExecutePrompt(null)} />
            <IconButton
                size="large"
                type='button'
                onClick={() => setCommandExecutePrompt({ title: "Execute Command", message: "Enter the command to execute" })}
                color="inherit"
                style={squareHighlightStyle}
            >
                <Tooltip title='Execute Comand'>
                    <ArrowForwardIosIcon />
                </Tooltip>
            </IconButton>
        </>
    );
}
